import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {BaseRouteService} from './BaseRouteService';
import type {ViewModeType} from './IRouteService';

export class VendorPendingPersonnelRouteService extends BaseRouteService {
  constructor(
    enableGoHome: boolean,
    mode: ViewModeType,
    parameters: {[key: string]: any}
  ) {
    super(enableGoHome, mode, parameters);
  }

  getCreateRoute(): string {
    throw 'Not implemented.';
  }

  getEditRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const vendorId = this.parameters['vendorId'];
    return PathUtility.VendorPendingPersonnelEdit(id, vendorId, view);
  }

  getViewRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const vendorId = this.parameters['vendorId'];
    return PathUtility.VendorPendingPersonnelView(id, vendorId, view);
  }

  getGoBackRoute(id?: string | number): string {
    switch (this.mode) {
      case 'create':
      case 'view':
        return this.getGoHomeRoute();

      case 'edit':
        return this.getViewRoute(id!);

      default:
        return '';
    }
  }

  getGoHomeRoute(): string {
    return PathUtility.Vendors('pending');
  }
}
